/// <amd-module name="Build/Common/FeaturePlugins/PipelineFeaturePlugin" />
import * as React from "react";

import * as Resources from "Build/Common/FeaturePlugins/Resources";
import { Services, VssService } from "VSS/Platform/Context";
import { IProductFeaturePluginService } from "TFS/Admin/Common/Util/ProductFeaturePlugin";
import { ContributedFeature } from "TFS/FeatureManagement/Contracts/FeatureManagement";

class PipelineFeaturePluginService extends VssService implements IProductFeaturePluginService {
    public getFeatureDisableMessage(feature: ContributedFeature): Promise<JSX.Element | undefined> {
        return Promise.resolve(
            <div className="caution fontWeightHeavy">
                {Resources.DisablePipelinesMessage}
            </div>);
    }
}

Services.add("pipelines-product-feature-plugin-service", { serviceFactory: PipelineFeaturePluginService });